import { useModalContext } from '#pplx/frontend/aether/modals/context/useModalContext.js';
import { useSetThreadTitle } from '#pplx/frontend/apps/ask/hooks/threads-hooks/useSetThreadTitle.js';
import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
import { useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';
const ThreadTitleEditModal = Dynamic(async () => {
    const { ThreadTitleEditModal } = await import('#pplx/frontend/apps/ask/search/modals/ThreadTitleEditModal.js');
    return { default: ThreadTitleEditModal };
});
const SidebarThreadRenameModal = Dynamic(async () => {
    const { SidebarThreadRenameModal } = await import('#pplx/frontend/apps/ask/hooks/threads-hooks/SidebarThreadRenameModal.js');
    return { default: SidebarThreadRenameModal };
});
function buildThreadMenuItems(props, renameLabel, deleteLabel, onRenameClick) {
    return [
        {
            text: renameLabel,
            icon: $icon('pencil'),
            onClick: onRenameClick,
            type: 'default',
            show: props.showRename ?? true,
        },
        {
            text: props.deleteLabel ?? deleteLabel,
            icon: $icon('trash'),
            onConfirm: props.onDelete,
            type: 'destructive',
            confirmation: props.deleteConfirmation,
        },
    ];
}
export function useSidebarThreadActionsFactory() {
    const { $t } = useIntl();
    const { openModal } = useModalContext();
    const renameLabel = $t({
        defaultMessage: 'Rename',
        description: 'Label for the rename action in the sidebar thread context menu',
        id: '772082585a',
    });
    const deleteLabel = $t({
        defaultMessage: 'Delete',
        description: 'Label for the delete action in the sidebar thread context menu',
        id: '9616a15a43',
    });
    return useCallback((props, onRenameClick) => ({
        menuItems: buildThreadMenuItems(props, renameLabel, deleteLabel, onRenameClick ?? (() => openModal(SidebarThreadRenameModal, props, { replace: true }))),
    }), [openModal, renameLabel, deleteLabel]);
}
export const useSidebarThreadActions = ({ title, contextUUID, onDelete, onRenameComplete, showRename = true, deleteLabel, deleteConfirmation, threadRenameAnalytics, }) => {
    const { openModal } = useModalContext();
    const getActions = useSidebarThreadActionsFactory();
    const { handleTitleSave, title: titleInternal } = useSetThreadTitle({
        title,
        contextUUID,
        rwToken: '',
        callback: onRenameComplete,
        threadRenameAnalytics,
    });
    const onRenameClick = useCallback(() => {
        openModal(ThreadTitleEditModal, {
            defaultTitle: titleInternal,
            onSave: handleTitleSave,
        }, { replace: true });
    }, [openModal, titleInternal, handleTitleSave]);
    return useMemo(() => getActions({ title, contextUUID, onDelete, showRename, deleteLabel, deleteConfirmation }, onRenameClick), [
        contextUUID,
        title,
        deleteConfirmation,
        deleteLabel,
        getActions,
        onDelete,
        onRenameClick,
        showRename,
    ]);
};
//# sourceMappingURL=useSidebarThreadActions.js.map